import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=1af4bc71&"
import script from "./buttons.vue?vue&type=script&lang=js&"
export * from "./buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports